import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import CardHeader from '@material-ui/core/CardHeader';

import IconButton from '@material-ui/core/IconButton';
import FavoriteIcon from '@material-ui/icons/Favorite';
import Divider from '@material-ui/core/Divider';
import Button from '@material-ui/core/Button';
import Chip from '@material-ui/core/Chip';
import Avatar from '@material-ui/core/Avatar';
import PhoneIcon from '@material-ui/icons/Phone';

import ShopCardPriceRow from './ShopCardPriceRow';

const hebrewLables = {
  freeShipping: 'משלוח חינם',
  lastPurchase: 'רכישה אחרונה: {x}',  
  likeButtonTextToggleOff: 'לחץ לסמן שאתה אוהב את המוצר',  
  alignType: 'איזון סטטי',
  learnMoreButtonText: 'מידע נוסף',
  chooseCTA: 'בחר מוסך',
};

const styles = theme => ({
  card: {
    marginTop: 15,
    maxWidth: 370,
    marginLeft: 'auto',
    marginRight: 'auto',
    position: 'relative',
  },
  youtube: {
    maxWidth: 400,
    width: '100%',
    height: 245,
  },
  content: {
    padding: 5,
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
  media: {
    height: 194,
    backgroundPosition: 'top',
  },
  brandLogo: {
    height: 25,
    position: 'absolute',
    top: 5,
    right: 5,
  },
  actions: {
    display: 'flex',
  },
  likesCounter: Object.assign({}, theme.typography.button, {
    margin: theme.spacing(),
  }),
  youtubeContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
  table: {
    maxWidth: 300,
  },
  expand: {
    transform: 'rotate(0deg)',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
    marginLeft: 'auto',
  },
  '@media (min-width: 1024px)': {
    button: {
      width: 319,
    },
  },
  button: {
    margin: theme.spacing(),
    width: '100%',
  },
  description: {
    padding: theme.spacing(2),
  },
  cardMediaContainer: {
    position: 'relative',
  },
  liked: {
    color: '#ef7600',
  },
  shopPhone: {
    flip: false,
    position: 'absolute',
    top: 8,
    left: 10,
  },
  trendingChip: {
    margin: theme.spacing(),
  },
});

class ShopCard extends React.Component {
  state = { expanded: false };

  handleExpandClick = () => {
    this.setState({ expanded: !this.state.expanded });
  };

  pickShop = () => {
    this.props.onPickShop(this.props.data.id);
  };

  reportLike = () => {
    /* eslint no-underscore-dangle: 0 */
    this.props.reportLike(this.props.data._id);
  };

  render() {
    const { classes, data, stats, isSet, cart } = this.props;

    const { _id, displayName, phone, address, photo, likes } = data;

    const liked =
      stats.data.likes.shops.findIndex(p => p.shopId === _id) !== -1
        ? classes.liked
        : '';

    return (
      <Card className={classes.card}>
        <CardHeader
          className={classes.cardHeader}
          title={displayName}
          subheader={address}
        />
        <Chip
          avatar={
            <Avatar>
              <PhoneIcon />
            </Avatar>
          }
          className={classes.shopPhone}
          label={phone}
        />
        <Divider />
        <div className={classes.cardMediaContainer}>
          <CardMedia
            className={classes.media}
            image={photo}
            title={displayName}
          />
        </div>
        <Divider />
        <CardContent className={classes.content}>
          <ShopCardPriceRow data={data} isSet={isSet} cart={cart} />
        </CardContent>
        <Divider />
        <CardActions className={classes.actions}>
          <div className={classes.likesCounter}>{likes}</div>
          <IconButton
            onClick={this.reportLike}
            aria-label={hebrewLables.likeButtonTextToggleOff}
          >
            <FavoriteIcon className={liked} />
          </IconButton>

          <Button
            onClick={this.pickShop}
            variant="contained"
            color="primary"
            className={classes.button}
          >
            {hebrewLables.chooseCTA}
          </Button>
        </CardActions>
      </Card>
    );
  }
}

ShopCard.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  stats: PropTypes.object,
  isSet: PropTypes.bool,
  cart: PropTypes.object,
  addToCart: PropTypes.func,
  onPickShop: PropTypes.func.isRequired,
  reportLike: PropTypes.func.isRequired,
};

export default withStyles(styles)(ShopCard);
